// 编辑弹窗的一些平台配置
import {
  getGoodsBaseInfo,
  editGoodsBaseInfo
} from '@/servers/prod/center'
import {getKsDetail, _formatGoodsItem as ksDataMap, editKsDetail,editKsDetail2, getKsDetailSupplier} from '@/servers/prod/center/kuaishou.js'
import {getFxgDetail,fxgDataMap, editFxgInfo,editFxgInfo2, getFxgDetailSupplier} from '@/servers/prod/center/fxg.js'
import {getPddDetail,pddDataMap, editPddInfo,editPddInfo2, getPddDetailSupplier} from '@/servers/prod/center/pdd.js'
import {getJdDetail, _formatGoodsItem as jdDataMap, editJdDetail,editJdDetail2, getJdDetailSupplier} from '@/servers/prod/center/jd.js'
import { getTbDetail,_formatGoodsItem as tbDataMap, editTbDetail,editTbDetail2 ,getTbDetailSupplier } from '@/servers/prod/center/tb.js'
import { getTmDetail, _formatGoodsItem as tmDataMap, editTmDetail,editTmDetail2, getTmDetailSupplier } from '@/servers/prod/center/tm.js'
import { getAlibabaDetail, _formatGoodsItem as alibabaDataMap, editAlibabaDetail,editAlibabaDetail2, getAlibabaDetailSupplier } from '@/servers/prod/center/alibaba.js'
import {getTaoTeDetail, _formatGoodsItem as taoteDataMap, editTjbDetail} from '@/servers/prod/center/tjb.js'
import { getYzDetail, _formatGoodsItem as yzDataMap, editYzDetail } from '@/servers/prod/center/yz.js'
import { getWxhDetail, _formatGoodsItem as wxhDataMap, editWxhDetail,editWxhDetail2 } from '@/servers/prod/center/wxh.js'
import {getWxxdDetail, _formatGoodsItem as wxxdDataMap, editWxxdDetail, getWxxdDetailSupplier} from '@/servers/prod/center/wxxd.js'
import {getXhsDetail, _formatGoodsItem as xhsDataMap, editXhsInfo,editXhsInfo2} from '@/servers/prod/center/xhs.js'
import { getMtDetail, editYyjkInfo} from '@/servers/prod/center/mt.js'
import { getXianyuDetail, _formatGoodsItem as xianyuDataMap, editXianyuInfo} from '@/servers/prod/center/xianyu.js'
import {getSheinDetail, _formatGoodsItem as SheinDataMap, editSheinInfo} from '@/servers/prod/center/shein.js'
import { getTemuDetail,getTemuBtgDetail, _formatGoodsItem as temuDataMap,_formatGoodsItemBtg, editTemuInfo,editTemuBtgInfo} from '@/servers/prod/center/temu.js'
import {getJdmsDetail, _formatGoodsItem as jdmsDataMap, editJdmsDetail} from '@/servers/prod/center/jdms.js'
import {getWdDetail, _formatGoodsItem as wdDataMap, editWdDetail} from '@/servers/prod/center/wd.js'

import BaseInfoForm from '../components/BaseInfoForm/index.vue';
import KjBaseInfoForm from '../components/KjBaseInfoForm/index.vue';
import DdianInfoForm from '../components/DdianInfoForm/index.vue';
import KuaishouInfoForm from '../components/KuaishouInfoForm/index.vue';
import PddInfoForm from '../components/PddInfoForm/index.vue';
import JdongInfoForm from '../components/JdongInfoForm/index.vue';
import TBInfoForm from '../components/TBInfoForm/index.vue'
import TMInfoForm from '../components/TMInfoForm/index.vue'
import AlibabaInform from '../components/AlibabaInfoForm/index.vue'
import TJBInfoForm from '../components/TJBInfoForm/index.vue'
import YouZanInfoForm from '../components/YouZanInfoForm/index.vue'
import WxhInfoForm from '../components/WxhInfoForm/index.vue'
import WxxdInfoForm from '../components/WxxdInfoForm/index.vue'
import WdInfoForm from '../components/WdInfoForm/index.vue';
import XhsInfoForm from '../components/XhsInfoForm/index.vue';
import MTShanGouInfoForm from '../components/MTShanGouInfoForm/index.vue';
import XianyuInfoForm from '../components/XianyuInfoForm/index.vue';
import SheinForm from '../components/SheinForm/index.vue';
import TemuInfoForm from '../components/TemuInfoForm/index.vue';
import TemuSemiInfoForm from '../components/TemuSemiInfoForm/index.vue';
import JdmsjInfoForm from '../components/JddjInfoForm/index.vue';

/************* 新加入的平台请补全下面的配置 *********/
export const PLATFORM = ["base", "fxg", "kuaishou", 'tb', 'tm',
"pdd",
"jd",
"alibaba",
'yz',
"wxsph",
// 'wxxd',
'wd',
'xhs',
'yyjk',
'xy',
'shein',
'jdms'
]
export const KJ_PLATFORM = ['kjBase','pddtemu'] // 跨境平台

// 平台分类：国内平台 vs 跨境平台
export const PLATFORM_CATEGORY = {
  'gn': {
    label:'商品编辑',
    platform:PLATFORM
  },
  'kj': {
    label:'跨境商品编辑',
    platform:KJ_PLATFORM
  }
}

export const PLATFORM_NAMES = {
  'base': '基础',
  'kjBase': '基础',
  'fxg': '抖音',
  'kuaishou': '快手',
  'tb': '淘宝',
  'tm': '天猫',
  'pdd': '拼多多',
  'jd': '京东',
  'alibaba': '1688',
  'tjb': '淘特',
  'yz': '有赞',
  'wxsph': '微信小店（视频号）',
  // 'wxxd': '微信小店',
  'wd': '微店',
  'xhs': '小红书',
  'yyjk': '美团闪购',
  'xy': '闲鱼',
  'shein':'Shein',
  'pddtemu': 'Temu',
  'pddtemu_btg': 'Temu半托管',
  'jdms': '京东到家',
}
/**
 * 平台销售价名词
 */
export const PLATFORM_SALES_PRICE_NAMES = {
  'base': '销售价',
  'fxg': '价格/售卖价',
  'kuaishou': '价格',
  'tb': '价格/一口价',
  'tm': '价格',
  'pdd': '拼单价',
  'jd': '京东价',
  'alibaba': '单价',
  '1688': '单价',
  'tjb': '特价',
  'yz': '价格',
  'wxsph': '售卖价',
  'wxxd': '售卖价',
  'wd': '商品价格',
  'xhs': '售价',
  'xy': '售价',
  'pddtemu': '售价',
  'pddtemu_btg': '售价',
}
/**
 * 平台市场价名词
 */
export const PLATFORM_MARKET_PRICE_NAMES = {
  'base': '市场价',
  'fxg': '划线价',
  'kuaishou': '/',
  'tb': '/',
  'tm': '/',
  'pdd': '单买价/参考价',
  'jd': '市场价',
  'alibaba': '/',
  '1688': '/',
  'tjb': '划线价',
  'yz': '划线价',
  'wxsph': '市场价',
  'wxxd': '市场价',
  'wd': '划线价',
  'xhs': '/',
  'xy': '/',
  'pddtemu': '/',
  'pddtemu_btg': '/',
}
/**
 * 平台类型映射大写
 */
export const PLATFORM_MAPPING = {
  'wd': 'WD',
  'tm': 'TM',
}
// 平台组件索引
const PLATFORM_FORM_COMPS = {
  'base': BaseInfoForm,
  'kjBase': KjBaseInfoForm,
  'fxg': DdianInfoForm,
  'kuaishou': KuaishouInfoForm,
  'tb': TBInfoForm,
  'tm': TMInfoForm,
  'pdd': PddInfoForm,
  'jd': JdongInfoForm,
  'alibaba': AlibabaInform,
  'tjb': TJBInfoForm,
  'yz': YouZanInfoForm,
  'wxsph': WxhInfoForm,
  'wxxd': WxxdInfoForm,
  'wd': WdInfoForm,
  'xhs': XhsInfoForm,
  'yyjk': MTShanGouInfoForm,
  'xy': XianyuInfoForm,
  'shein':SheinForm,
  'pddtemu': TemuInfoForm,
  'pddtemu_btg': TemuSemiInfoForm,
  'jdms': JdmsjInfoForm,
}

// 平台信息解析方法
export const PLATFORM_INFO_PARSE = {
  'fxg': fxgDataMap,
  'pdd': pddDataMap,
  'kuaishou': ksDataMap,
  'tb': tbDataMap,
  'tm': tmDataMap,
  'jd': jdDataMap,
  'alibaba': alibabaDataMap,
  'tjb': taoteDataMap,
  'yz': yzDataMap,
  'wxsph': wxhDataMap,
  'wxxd': wxxdDataMap,
  'xhs': xhsDataMap,
  'xy': xianyuDataMap,
  'pddtemu': temuDataMap,
  'pddtemu_btg': _formatGoodsItemBtg,
  'jdms':jdmsDataMap
}
// 平台信息接口
export const PLATFORM_INFO_API = {
  'base': getGoodsBaseInfo,
  'kjBase': getGoodsBaseInfo,
  'fxg': getFxgDetail,
  'kuaishou': getKsDetail,
  'tb': getTbDetail,
  'tm': getTmDetail,
  'pdd': getPddDetail,
  'jd': getJdDetail,
  'alibaba': getAlibabaDetail,
  'tjb': getTaoTeDetail,
  'yz': getYzDetail,
  'wxsph': getWxhDetail,
  'wxxd': getWxxdDetail,
  'xhs': getXhsDetail,
  'yyjk': getMtDetail,
  'xy': getXianyuDetail,
  'shein': getSheinDetail,
  'pddtemu': getTemuDetail,
  'pddtemu_btg': getTemuBtgDetail,
  'jdms': getJdmsDetail,
  'wd':getWdDetail,
}

// 平台信息接口(供销商小店版)
export const PLATFORM_INFO_API_SUPPLIER = {
  'fxg': getFxgDetailSupplier,
  'kuaishou': getKsDetailSupplier,
  'tb': getTbDetailSupplier,
  'tm': getTmDetailSupplier,
  'pdd': getPddDetailSupplier,
  'jd': getJdDetailSupplier,
  'alibaba': getAlibabaDetailSupplier,
  'wxxd': getWxxdDetailSupplier,
  'xhs': getFxgDetailSupplier,
}
// 平台编辑信息接口
export const PLATFORM_EDIT_API = {
  'base': editGoodsBaseInfo,
  'kjBase': editGoodsBaseInfo,
  'fxg': editFxgInfo,
  'kuaishou': editKsDetail,
  'tb': editTbDetail,
  'tm': editTmDetail,
  'pdd': editPddInfo,
  'jd': editJdDetail,
  'alibaba': editAlibabaDetail,
  'tjb': editTjbDetail,
  'yz': editYzDetail,
  'wxsph': editWxhDetail,
  'wxxd': editWxxdDetail,
  'xhs': editXhsInfo,
  'yyjk': editYyjkInfo,
  'xy': editXianyuInfo,
  'shein': editSheinInfo,
  'pddtemu': editTemuInfo,
  'pddtemu_btg': editTemuBtgInfo,
  'jdms': editJdmsDetail,
  'wd': editWdDetail,
}
// 平台编辑信息接口
export const PLATFORM_EDIT_API2 = {
  'pdd':editPddInfo2,
  'kuaishou': editKsDetail2,
  'alibaba': editAlibabaDetail2,
  'fxg': editFxgInfo2,
  'wxsph': editWxhDetail2,
  'xhs': editXhsInfo2,
  'tb': editTbDetail2,
  'tm': editTmDetail2,
  'jd': editJdDetail2,
}
// 平台信息接口所需参数索引
// _this -> EditDialog.vue实例中的this
export function getPlatformInfoParams(_this, {isDistributor, isFromSupplierShop = false }={}) {
  return {
    // 'base': isDistributor ? _this.baseItemId : _this.id,
    'base': _this.baseItemId,
    'kjBase': _this.baseItemId,
    'fxg': {baseItemId: _this.baseItemId},
    'kuaishou': isFromSupplierShop ? { baseItemId: _this.baseItemId } : _this.baseItemId,
    'tb': { baseItemId: _this.baseItemId },
    'tm': { baseItemId: _this.baseItemId, shopIds: _this.shopId },
    'pdd': {baseItemId: _this.baseItemId},
    'jd': isFromSupplierShop ? { baseItemId: _this.baseItemId } : _this.baseItemId,
    'alibaba': isFromSupplierShop ? { baseItemId: _this.baseItemId } : _this.baseItemId,
    'tjb': { baseItemId: _this.baseItemId },
    'yz': _this.baseItemId,
    'wxsph': _this.baseItemId,
    'wxxd': isFromSupplierShop ? { baseItemId: _this.baseItemId } : _this.baseItemId,
    'xhs': {baseItemId: _this.baseItemId},
    'yyjk': {baseItemId: _this.baseItemId},
    'xy': {baseItemId: _this.baseItemId},
    'shein': {baseItemId: _this.baseItemId},
    'pddtemu': {baseItemId: _this.baseItemId},
    'pddtemu_btg': {baseItemId: _this.baseItemId},
    'jdms': _this.baseItemId,
    'wd': _this.baseItemId,
  }
}

/************* 新加入的平台请补全上面的配置 *********/


// 格式化平台表单组件的name
export function getPlatformFormComps() {
  let compsObj = {}
  let list = [...PLATFORM,...KJ_PLATFORM] 
  list.forEach(p => {
    compsObj[`${p}Form`] = PLATFORM_FORM_COMPS[p]
  });
  return compsObj
}
// 获取不同平台loading控制初始化对象
export function getLoadingInit() {
  let list = [...PLATFORM,...KJ_PLATFORM] 
  return list.reduce((loadingObj, currPlatform) => {
    loadingObj[currPlatform] = false;
    return loadingObj
  }, {})
}
// 生成不同平台的基本表单
export function getFormInit() {
  const formObj = {}
  let list = [...PLATFORM,...KJ_PLATFORM] 
  list.forEach(platform => {
    formObj[`${platform}Form`] = {}
  })

  return formObj
}



